import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[spinnerHost]',
})
export class SpinnerhostDirective {
    constructor(public viewContainerRef: ViewContainerRef) {}
}
